import { render, staticRenderFns } from "./ClientReport.vue?vue&type=template&id=36142c3e&scoped=true&"
import script from "./ClientReport.vue?vue&type=script&lang=js&"
export * from "./ClientReport.vue?vue&type=script&lang=js&"
import style0 from "./ClientReport.vue?vue&type=style&index=0&id=36142c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36142c3e",
  null
  
)

export default component.exports